import React, { useState, useMemo, useRef } from 'react';
import FormControl from '@material-ui/core/FormControl';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import EditModules from '../Core/Dialog/EditModules';
import Button from '../Core/Button/Button';
import InputSelect from '../Core/InputSelect';
import Input from '../Core/Input/Input';
import SearchIcon from '../Icons/SearchIcon';
import GenerateApiKeyDialog from '../Core/Dialog/GenerateApiKey';

import styles from './orgList.module.scss';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: '5px 5px 5px 0',
    width: 189,

    '& > input': {
      height: 36,
    },
  },
  label: {
    color: '#808F94',
    fontSize: 14,
    fontWeight: 600,
    transform: 'translate(0, 1.5px) scale(1)',
  },
}));

export default function Filter({
  organizations,
  handleChangeOrganizations,
  changeStatusCompany,
  checkedItems,
  selectedItem,
  enterOrganization,
  clearCheckbox,
  query,
  onChangeQuery,
}) {
  const classes = useStyles();
  const { t } = useTranslation();  
  
  const [open, setOpen] = useState(false);

  const generateApiKeyDialogRef = useRef();

  const handleClose = () => {
    clearCheckbox();
    setOpen(false);
  };

  const options = useMemo(() => [
    {
      value: 3,
      label: 'All organizations',
    },
    {
      value: 1,
      label: 'Active',
    },
    {
      value: 0,
      label: 'Suspended',
    },
    {
      value: 2,
      label: 'Terminated',
    },
  ], []);

  return (
    <div className={styles.filterBlock}>
      <div>
        <FormControl className={classes.margin}>
          <InputSelect
            id='organizations-select'
            name='organizations'
            value={organizations}
            onChange={handleChangeOrganizations}
            options={options}
          />
        </FormControl>
        <FormControl className={classes.margin}>
          <Input
            icon={<SearchIcon />}
            placeholder={`${t('Search')}...`}
            value={query}
            onChange={(e) => onChangeQuery(e.target.value)}
          />
        </FormControl>
      </div>
      <div className={styles.filterBlock__inner}>
        <Button
          navyBlue
          onClick={() => generateApiKeyDialogRef.current.open(checkedItems[0] || selectedItem?.id)}
          disabled={(!checkedItems.length > 0 && !selectedItem) || checkedItems.length > 1}
        >
          {t('Manage API key')}
        </Button>
        <Button
          navyBlue
          onClick={() => setOpen(true)}
          disabled={(!checkedItems.length > 0 && !selectedItem) || checkedItems.length > 1}
        >
          {t('Edit Modules')}
        </Button>
        <Button
          onClick={() => { enterOrganization(); }}
          disabled={(!checkedItems.length > 0 && !selectedItem) || checkedItems.length > 1}
        >
          {t('Enter Organization')}
        </Button>
        <Button
          green
          onClick={() => changeStatusCompany('activate')}
          disabled={!checkedItems.length > 0 && !selectedItem}
        >
          {t('Activate')}
        </Button>
        <Button
          yellow
          onClick={() => changeStatusCompany('suspend')}
          disabled={!checkedItems.length > 0 && !selectedItem}
        >
          {t('Suspend')}
        </Button>
        <Button
          danger
          onClick={() => changeStatusCompany('delete')}
          disabled={!checkedItems.length > 0 && !selectedItem}
        >
          {t('Terminate')}
        </Button>
        <Button
          black
          onClick={() => changeStatusCompany('destroy')}
          disabled={!checkedItems.length > 0 && !selectedItem}
        >
          {t('Delete')}
        </Button>
      </div>
      <EditModules
        open={open}
        handleClose={handleClose}
        checkedItemId={checkedItems[0] || selectedItem?.id}
        title={t('Have access to these modules')}
      />
      <GenerateApiKeyDialog ref={generateApiKeyDialogRef} />
    </div>
  );
}
